import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Clock } from "lucide-react";
import api from "../lib/api";

// Persistent, app-wide banner for subscriptions in the Active (Cancelling) state.
// Shown only to the person who can act on it (the Household Admin / subscription owner).
export default function SubscriptionEndingBanner() {
  const [info, setInfo] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const refresh = () => api.get("/household/capacity").then((r) => setInfo(r.data)).catch(() => setInfo(null));

  useEffect(() => { refresh(); }, [location.pathname]);
  useEffect(() => {
    const onUpdate = (e) => {
      const detail = e?.detail;
      if (detail && detail.subscription_status) {
        // Authoritative status from the mutation response: set directly, no follow-up GET
        // (avoids a race with other concurrent /household/capacity reads).
        setInfo((prev) => ({ ...(prev || {}), ...detail }));
      } else {
        refresh();
      }
    };
    window.addEventListener("subscription-updated", onUpdate);
    return () => window.removeEventListener("subscription-updated", onUpdate);
  }, []);

  const status = info?.subscription_status || {};
  const cancelling = status.status === "active_cancelling";
  if (!cancelling || !info?.is_admin) return null;

  return (
    <div data-testid="app-subscription-ending-banner"
      className="border-b border-[#FDE68A] bg-[#FEF3C7] px-4 py-2.5 sm:px-8">
      <div className="mx-auto flex max-w-5xl flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <p className="flex items-start gap-2 text-sm leading-relaxed text-[#3f4a48]">
          <Clock className="mt-0.5 h-4 w-4 shrink-0 text-[#B45309]" strokeWidth={1.7} />
          <span>
            <span className="font-medium text-[#2D3436]">Your subscription is scheduled to end on {status.expiry_date}.</span>{" "}
            You'll keep full access until then. Continue your subscription any time before it expires to keep your plan.
          </span>
        </p>
        <button data-testid="banner-continue-subscription-btn" onClick={() => navigate("/app/billing")}
          className="shrink-0 self-start rounded-lg bg-[#0F766E] px-4 py-1.5 text-sm font-medium text-white transition-transform hover:-translate-y-0.5 sm:self-auto">
          Continue Subscription
        </button>
      </div>
    </div>
  );
}
